import { MessageBox } from 'mint-ui';
export default {
  methods: {
    goto (id) {
      this.$router.push(id)
    },
    jump(to) {
      if (this.$router) {
          this.$router.push(to)
      }
    },
    // 验证手机号
    topropPhone(val) {
      if(val.length < 11){
        alert('请输入11位手机号码');
        return true
      }else if(!(/^[1][0-9][0-9]{9}$/.test(val))){
        alert('手机号码输入格式有误');
        return true
      };
    },
    //短信验证码
    topropMessage(val){
      if(val.length !=6){
        alert("请输入6位短信验证码")
        return true
      }
    },
    msgManage(err){
      if(err.graphQLErrors&&err.graphQLErrors[0].message=="鉴权失败"){
        window.location.href="https://screen.xiaoyima.work/index.html"
      }else{
        MessageBox({
          title: '提示',
          message:err.message
        });
      }
    },
    showOneBtnAlert(msg){
      MessageBox({
        title: '提示',
        message:msg
      });
    },
    showOneBtnConfirm(msg,fun){
      MessageBox.alert(msg).then(action => {
       fun()
      });
    },
    showConfirm(msg,title,suc){
      MessageBox.confirm(msg,title).then(action => {
        suc
      })
    },
    isAndroid () {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
        if (isAndroid) {
                    return true
          } else {
                    return false
        }
      },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js